@if (isFocused()) {
  <div class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-50 tw-z-[9]"></div>
}
<div
  #searchPanel
  class="tw-relative tw-w-full tw-h-full tw-text-color-text-default tw-text-sm"
  [ngClass]="{ 'sm:tw-fixed sm:tw-inset-0 sm:tw-z-[10] sm:tw-bg-color-surface-card': isFocused() }"
  [class.mobile-slide-in-page]="isFocused() && isSmallScreen()"
  [style.paddingTop]="isFocused() ? 'var(--safe-area-top, 0px)' : null"
  [appScrollLock]="isFocused()"
  appClickOutside
  appClickOutsideFocusOut
  (clickOutside)="onClickOutside($event)"
>
  <div
    class="tw-flex tw-relative tw-items-center tw-h-full tw-w-full tw-z-[10]"
    [ngClass]="{ 'sm:tw-h-auto sm:tw-p-4 sm:tw-gap-2': isFocused() }"
  >
    <div class="tw-relative tw-w-full sm:tw-flex-1">
      <input
        #searchInput
        aria-label="Search input"
        role="searchbox"
        aria-controls="search-bar-results"
        type="text"
        placeholder="Search for accounts, transactions..."
        [ngModel]="input()"
        (ngModelChange)="input.set($event)"
        (focus)="onFocus()"
        [ngClass]="{
          'sm:tw-hidden': !isVisible(),
          'tw-rounded-t-2xl tw-rounded-b-none sm:tw-rounded-full tw-border-solid tw-border-color-border-subtle sm:tw-border-none':
            isFocused(),
          'tw-rounded-xl tw-border-transparent shadow-inset-neuomorphic': !isFocused(),
        }"
        class="tw-w-full tw-p-4 sm:tw-py-0 sm:tw-pl-5 sm:tw-h-10 tw-pr-12 tw-bg-dt-surface-elevated tw-text-sm sm:tw-text-[13px] placeholder:tw-text-color-text-disabled tw-border tw-text-ellipsis tw-whitespace-nowrap tw-caret-teal-500"
      />
      <button
        #searchIcon
        type="button"
        aria-label="Search"
        (click)="input() ? clearInput() : focusInputField()"
        [ngClass]="{ 'sm:tw-block': input() }"
        class="search-bar-icon tw-bg-dt-surface-elevated tw-rounded-full tw-p-1.5 tw-text-color-text-default sm:tw-bg-transparent sm:tw-rounded-none sm:tw-p-0"
      >
        <icon [name]="input() ? 'close' : 'magnifier'" [size]="5"></icon>
      </button>
    </div>
    <button
      aria-label="Clear search"
      (click)="hideInput()"
      [ngClass]="{ 'sm:tw-hidden': !isVisible() }"
      class="tw-hidden sm:tw-block sm:tw-shrink-0 tw-text-xs tw-tracking-[0.06px] tw-text-color-text-default"
    >
      {{ "cancel" | i18n }}
    </button>
  </div>

  @if (isFocused()) {
    <div
      id="search-bar-results"
      role="region"
      aria-label="Search tags, results and history"
      class="tw-absolute tw-top-full tw--mt-px tw-right-0 tw-w-full tw-min-w-[400px] sm:tw-min-w-full tw-max-w-dvw tw-bg-color-surface-elevated tw-z-[10] tw-rounded-b-2xl sm:tw-rounded-none tw-overflow-hidden tw-shadow-lg tw-border tw-border-t-0 tw-border-solid tw-border-color-border-subtle sm:tw-border-none"
      [ngClass]="{
        'sm:tw-static sm:tw-flex sm:tw-flex-col sm:tw-h-full sm:tw-overflow-hidden': isFocused(),
      }"
    >
      <!-- Tags -->
      <div class="tw-relative tw-bg-color-surface-card">
        <div
          #tagsRow
          (scroll)="onTagsScroll()"
          class="tw-flex tw-items-center tw-space-x-1 tw-overflow-x-auto hide-scrollbars tw-scroll-smooth tw-px-2 tw-py-2"
        >
          <ng-container *appRoleScope="'BETA_ACCESS'">
            <button
              type="button"
              (click)="onAskAiClick()"
              class="tw-flex tw-h-8 tw-shrink-0 tw-items-center tw-gap-1 tw-bg-color-accent-today-bg tw-text-color-text-action tw-px-3 tw-py-1 tw-mr-1 tw-rounded-full tw-text-xs tw-tracking-[0.06px] tw-font-medium tw-shadow-md tw-shadow-teal-500/20"
            >
              <icon [name]="'stars'" [size]="4"></icon>
              {{ "askAi" | i18n }}
            </button>
            <div class="tw-w-px tw-h-5 tw-shrink-0 tw-bg-color-border-subtle"></div>
          </ng-container>
          @if (isFreeUser()) {
            <button
              class="tw-flex tw-h-8 tw-shrink-0 tw-items-center tw-justify-center tw-border-2 tw-border-teal-500 hover:tw-bg-teal-500 tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-tracking-[0.06px] glare-border"
              (click)="onPremiumClick()"
            >
              {{ "premium" | i18n }}
            </button>
          }
          <div
            role="group"
            aria-label="Filter search results by type"
            class="tw-flex tw-items-center tw-space-x-1"
          >
            @for (tag of tags; track tag) {
              <button
                type="button"
                [attr.aria-pressed]="selectedTag() === tag"
                (click)="onTagClick(tag)"
                class="tw-flex tw-h-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-tracking-[0.06px] tw-transition-colors"
                [ngClass]="{
                  'tw-bg-color-surface-elevated tw-border tw-border-solid tw-border-dt-border-tertiary tw-font-medium tw-text-color-text-default tw-shadow-sm':
                    selectedTag() === tag,
                  'tw-border-2 tw-border-solid tw-border-dt-border-tertiary tw-text-dt-text-secondary hover:tw-text-color-text-action':
                    selectedTag() !== tag,
                }"
              >
                {{ tag | i18n }}
              </button>
            }
          </div>
          <div class="tw-w-6 tw-shrink-0"></div>
        </div>

        @if (canScrollTagsLeft()) {
          <button
            aria-label="Scroll tags left"
            (click)="scrollTags(-1)"
            class="tw-absolute tw-left-1 tw-top-1/2 tw--translate-y-1/2 tw-flex tw-h-7 tw-w-7 tw-box-border tw-items-center tw-justify-center tw-rounded-full tw-overflow-hidden tw-bg-teal-500 tw-bg-opacity-90 tw-shadow"
          >
            <icon
              [name]="'right-arrow'"
              [size]="4"
              [disableArrowOverride]="true"
              [currentColor]="'white'"
              class="tw-rotate-180"
            ></icon>
          </button>
        }
        @if (canScrollTagsRight()) {
          <button
            aria-label="Scroll tags right"
            (click)="scrollTags(1)"
            class="tw-absolute tw-right-1 tw-top-1/2 tw--translate-y-1/2 tw-flex tw-h-7 tw-w-7 tw-box-border tw-items-center tw-justify-center tw-rounded-full tw-overflow-hidden tw-bg-teal-500 tw-bg-opacity-90 tw-shadow"
          >
            <icon
              [name]="'right-arrow'"
              [size]="4"
              [disableArrowOverride]="true"
              [currentColor]="'white'"
            ></icon>
          </button>
        }
      </div>

      <!-- Show result/ history -->
      <div
        class="tw-overflow-x-hidden tw-overflow-y-auto tw-overscroll-contain tw-max-h-96 sm:tw-max-h-[600px] sm:tw-flex-1 hide-scrollbars"
      >
        @if (input()) {
          @if (existInDB()) {
            <ul class="tw-flex tw-flex-col tw-gap-2 tw-list-none tw-p-0 tw-bg-color-surface-card">
              @for (data of sortData(); track data.type) {
                <li
                  class="tw-bg-color-surface-elevated tw-shadow-[0px_8px_16px_-12px_rgba(0,0,0,0.04)] tw-pt-2 tw-px-3"
                >
                  @if (hasHeader()) {
                    <div class="tw-flex tw-items-center tw-justify-between tw-py-2">
                      <span
                        class="tw-text-sm tw-font-medium tw-tracking-[0.056px] tw-text-color-text-default tw-capitalize"
                      >
                        {{ getHeader(data.type) | i18n }}
                      </span>
                      @if (data.total > 3) {
                        <span
                          class="tw-text-sm tw-text-dt-text-secondary tw-cursor-pointer"
                          (click)="onViewAllClick(data.type)"
                        >
                          View all
                          <span class="tw-text-dt-text-action tw-underline">{{ data.total }}</span>
                          results
                        </span>
                      }
                    </div>
                  }

                  <ul class="tw-list-none tw-p-0">
                    @for (item of data.items; track trackById(item)) {
                      <li
                        (click)="redirect(item)"
                        class="tw-flex tw-items-center tw-justify-between hover:tw-bg-color-surface-elevated hover:tw-bg-opacity-75 tw-p-3 tw-cursor-pointer"
                      >
                        <div class="tw-flex tw-items-center">
                          @if (getIcon(item); as icon) {
                            @let iconVariant = getIconVariant(item);
                            <span
                              class="tw-mr-2 tw-flex tw-shrink-0 tw-items-center tw-justify-center"
                              [ngClass]="{
                                'tw-h-8 tw-w-8 tw-rounded-full tw-bg-color-accent-today-bg tw-text-color-text-action':
                                  iconVariant === 'background',
                                'tw-h-8 tw-w-8 tw-rounded-lg tw-border-2 tw-border-solid tw-border-dt-border-tertiary tw-bg-color-surface-elevated':
                                  iconVariant === 'border',
                              }"
                            >
                              <icon [name]="icon" [size]="5"></icon>
                            </span>
                          }

                          <div>
                            <span [innerHTML]="highlightMatch(getData(item))"></span>

                            @let transactionDate = getTransactionDate(item);
                            @let ambiguousDate = hasAmbiguousDate(item, data.ambiguousDateKeys);
                            @if (transactionDate) {
                              <br />
                              <span class="tw-font-normal tw-text-dt-text-secondary">
                                {{ transactionDate | date: "yyyy-MM-dd" }}
                                @if (ambiguousDate) {
                                  · {{ getTimeLabel(item) }}
                                }
                              </span>
                            }
                          </div>
                        </div>
                        @let amount = getAmount(item);
                        @if (amount !== null) {
                          <span
                            class="tw-font-medium tw-whitespace-nowrap"
                            [ngClass]="{
                              'tw-text-dt-text-in-primary': amount > 0,
                              'tw-text-dt-text-out-primary': amount < 0,
                              'tw-text-dt-text-secondary': amount === 0,
                            }"
                          >
                            {{ amount | number: "1.2-2" }}
                            <span class="tw-text-[10px] tw-font-normal">{{
                              getCurrency(item)
                            }}</span>
                          </span>
                        } @else {
                          <icon [name]="'right-arrow'" [size]="4"></icon>
                        }
                      </li>
                    }
                  </ul>
                </li>
              }
            </ul>
          } @else {
            <div
              class="tw-flex tw-flex-col tw-space-y-2 tw-items-center tw-justify-center tw-text-center tw-h-72 sm:tw-h-screen"
            >
              <img
                loading="lazy"
                src="../../../images/dog.png"
                alt="Dog Icon"
                class="tw-w-[96px] tw-h-[68px]"
              />
              <span class="tw-text-lg tw-text-color-text-default">{{ "oops" | i18n }}!</span>
              <span class="tw-text-sm tw-text-color-text-disabled">{{ "noResult" | i18n }}</span>
            </div>
          }
        } @else {
          @if (history().length > 0) {
            <div class="tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-2">
              <span class="tw-text-sm tw-text-dt-text-secondary tw-uppercase">{{
                "recentlySearched" | i18n
              }}</span>
              <button
                (click)="clearHistory()"
                class="tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-1 tw-rounded-lg tw-border tw-border-transparent hover:tw-border-color-border-subtle hover:tw-bg-color-surface-card"
              >
                <span class="tw-text-xs tw-mr-1.5 tw-text-color-text-default">{{
                  "clearAll" | i18n
                }}</span>
                <icon [name]="'trash-bin'" [size]="4" [currentColor]="'color-icon-default'"></icon>
              </button>
            </div>

            <ul class="tw-list-none tw-p-0">
              @for (data of history(); track data) {
                <li
                  (click)="redirect(data)"
                  class="tw-flex tw-items-center tw-justify-between hover:tw-bg-color-surface-elevated hover:tw-bg-opacity-75 tw-p-3 tw-cursor-pointer"
                >
                  <div class="tw-flex tw-items-center">
                    @if (getIcon(data); as icon) {
                      @let iconVariant = getIconVariant(data);
                      <span
                        class="tw-mr-2 tw-flex tw-shrink-0 tw-items-center tw-justify-center"
                        [ngClass]="{
                          'tw-h-8 tw-w-8 tw-rounded-full tw-bg-color-accent-today-bg tw-text-color-text-action':
                            iconVariant === 'background',
                          'tw-h-8 tw-w-8 tw-rounded-lg tw-border-2 tw-border-solid tw-border-dt-border-tertiary tw-bg-color-surface-elevated':
                            iconVariant === 'border',
                        }"
                      >
                        <icon [name]="icon" [size]="5"></icon>
                      </span>
                    }
                    <span>{{ getData(data) }}</span>
                  </div>
                  <icon [name]="'right-arrow'" [size]="4"></icon>
                </li>
              }
            </ul>
          } @else {
            <div class="tw-flex tw-items-center tw-justify-center tw-h-64 sm:tw-h-screen">
              <span class="tw-text-sm tw-text-color-text-disabled">{{ "noHistory" | i18n }}</span>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
